import { useState } from 'react';
import { Outlet } from 'react-router';

import type { HeaderPatientInfo } from '@/components/layout/Header.tsx';
import { Header } from '@/components/layout/Header.tsx';

export type TrackingOutletContext = {
  setHeaderPatientInfo: (info: HeaderPatientInfo | null) => void;
};

export function TrackingLayout() {
  const [headerPatientInfo, setHeaderPatientInfo] = useState<HeaderPatientInfo | null>(null);

  return (
    <div className="flex min-h-svh flex-col">
      <Header patientInfo={headerPatientInfo} />
      <main className="flex flex-1 flex-col">
        <Outlet context={{ setHeaderPatientInfo } satisfies TrackingOutletContext} />
      </main>
    </div>
  );
}
